import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, useLocation, useNavigate, Navigate, useParams } from "react-router-dom";
import { cleanSession } from "../redux/slices/sessionSlice";
import { LoginScreen, MainScreen } from "../screens";
import { AdminScreen, CreateUserScreen, EditUserScreen, UserScreen } from "../screens/security/user";
import { CreateRoleScreen, EditRoleScreen, RoleScreen } from "../screens/security/role";
import { CreatePermissionScreen, EditPermissionScreen, PermissionScreen } from "../screens/security/permission";
import { PanelBinnacleScreen, PanelPaymentsScreen, PanelScreen, PanelTransactionsScreen } from "../screens/panel";
import { CreateExtraDenominationScreen, CreateLawfulOperatorScreen, CreatePINScreen, CreateSegmentPINScreen, DenominationScreen, EditExtraDenominationScreen, EditLawfulOperatorScreen, EditPINScreen, EditSegmentPINScreen, ExtraDenominationScreen, OperatorScreen, PINScreen, PaymentServiceScreen, ProductCreateDenominationScreen, ProductCreateOperatorScreen, ProductCreateSegmentScreen, ProductEditDenominationScreen, ProductEditOperatorScreen, ProductEditSegmentScreen, ProductLawfulOperatorScreen, ProductScreen, ProductTabScreen, ProductsPINScreen, ProductsPaymentServiceScreen, SegmentScreen, SegmentsPINScreen } from "../screens/admin/product";
import { CreateProviderScreen, EditProviderScreen, ProviderScreen, MonitorProviderTransactionsScreen, HebeCodesScreen, HebeCodesCreateScreen, HebeCodesEditScreen, ProviderStatusQueriesScreen } from "../screens/admin/provider";
import { CredsScreen, CredsAddScreen, CredsEditService, AmountsScreen, CarriersScreen, CreateAmountScreen, EditAmountScreen, CredTAEScreen, CredPDSScreen, CredPDSSegmentScreen, CredsProductTabScreen, CredPDSProductScreen, EditCredPDSProductScreen, CredPINScreen, CredPINSegmentScreen, CredPINProductScreen, EditCredPINProductScreen, CredTAEOperatorsScreen, CredTAESegmentsScreen, CredTAEProductsScreen } from "screens/admin/provider/creds";
import { ConnectorScreen, CreateConnectorScreen, EditConnectorScreen } from "../screens/admin/connector";
import { CreateLadaScreen, EditLadaScreen, LadasScreen } from "../screens/route/ladas";
import { AirTimeSaleScreen, ElectronicPinSaleScreen, SaleTabScreen, ServicePaymentSaleScreen } from "../screens/sale";
import { BalancesScreen, BinnacleScreen, DetailedScreen, ConciliacionScreen, ConciliacionHistoryScreen, ConciliacionDetailScreen, NetworkReportScreen, ConciliacionDiariaScreen, LiberacionesReportScreen, SearchTxnReportScreen } from "../screens/report";
import { CommerceScreen, CommerceTreeScreen, CreateCommerceScreen, EditCommerceScreen } from "../screens/client/commerce";
import { BagOperationsScreen, BagPDSProductScreen, BagPDSScreen, BagPDSSegmentScreen, BagPINProductScreen, BagPINScreen, BagPINSegmentScreen, BagProductTabScreen, BagTAEScreen, BagScreen, CreateBagScreen, EditBagScreen, BagTAEOperatorScreen, BagTAERegionScreen, BagTAESegmentScreen, BagTAEDenominationScreen } from "../screens/client/bag";
import { CreateSalePointScreen, EditSalePointScreen, SalePointScreen } from "../screens/client/salePoint";
import SimulatorScreen from "../screens/route/simulator/SimuladorScreen";
import TotalReportScreen from "screens/report/TotalReportScreen";
import { CreateGroupScreen, EditGroupScreen, GroupScreen } from "screens/client/group";
import DailyTotalReportScreen from "screens/report/DailyTotalReportScreen";
import CreatePaymentServiceScreen from "screens/admin/product/pds/CreatePaymentServiceScreen";
import EditPaymentServiceScreen from "screens/admin/product/pds/EditPaymentServiceScreen";
import SegmentsPaymentServiceScreen from "screens/admin/product/pds/SegmentsPaymentServiceScreen";
import CreateSegmentPaymentServiceScreen from "screens/admin/product/pds/CreateSegmentPaymentServiceScreen";
import EditSegmentPaymentServiceScreen from "screens/admin/product/pds/EditSegmentPaymentServiceScreen";
import { AlertMonitorScreen, AlertTab, AlertsScreen, CreateAlertScreen, EditAlertScreen, IntermittenceScreen, IntermittenceTxnsScreen } from "screens/admin/alerts";
import AlertTxnsMonitorScreen from "screens/admin/alerts/AlertTxnsMonitorScreen";
import { ServiceMonitorHistorialScreen, ServiceMonitorScreen } from "screens/admin/serviceMonitor";
import { CreateExceptionScreen, EditExceptionScreen, ExceptionScreen, RouteTabScreen, TAERouteScreen, TAETabScreen, ExceptionHistoryScreen, ExceptionHistoryTxnsScreen } from "screens/route/ruteo";
import PDSRouteScreen from "screens/route/ruteo/pds/PDSRouteScreen";
import PINRouteScreen from "screens/route/ruteo/pin/PINRouteScreen";
import EditCredTAEProductScreen from "screens/admin/provider/creds/tae/EditCredTAEProductScreen";
import Graficas from "screens/panel/Graficas";
import ErrorCodesTabScreen from "screens/admin/provider/errorcodes/ErrorCodesTabScreen";
import ErrorCodesHomologadosScreen from "screens/admin/provider/errorcodes/ErrorCodesHomologadosScreen";
import ErrorCodesRecibidosScreen from "screens/admin/provider/errorcodes/ErrorCodesRecibidosScreen";
import CreateErrorCodesScreen from "screens/admin/provider/errorcodes/CreateErrorCodesScreen";
import EditErrorCodesScreen from "screens/admin/provider/errorcodes/EditErrorCodesScreen";
import TransactionsAlertsScreen from "screens/admin/alerts/TransactionsAlertsScreen";
import SystemAlertsScreen from "screens/admin/alerts/SystemAlertsScreen";
import HomologationScreen from "screens/admin/provider/errorcodes/HomologationScreen";
import ErrorCodesRespaldoScreen from "screens/admin/provider/errorcodes/ErrorCodesRespaldoScreen";
import CreateErrorCodesRespaldoScreen from "screens/admin/provider/errorcodes/CreateErrorCodesRespaldoScreen";
import EditErrorCodesRespaldoScreen from "screens/admin/provider/errorcodes/EditErrorCodesRespaldoScreen";
import CreateCarrierScreen from "screens/admin/provider/creds/carriers/CreateCarrierScreen";
import EditCarrierScreen from "screens/admin/provider/creds/carriers/EditCarrierScreen";
import ProviderBalanceScreen from "screens/admin/provider/ProviderBalanceScreen";
import CommerceReportScreen from "screens/report/CommerceReportScreen";
import ProviderBalanceHistoryScreen from "screens/admin/provider/ProviderBalanceHistoryScreen";
import AbonosReportScreen from "screens/report/AbonosReportScreen";
import SettingsScreen from "screens/admin/server/SettingsScreen";
import PublicAlertTxnsMonitorScreen from "screens/admin/alerts/PublicAlertTxnsMonitorScreen";
import { CreateEmailReportScreen, EditEmailReportScreen, EmailReportScreen, EmailReportHistoryScreen, EmailReportTab, EmailReportGlobalHistoryScreen } from "screens/report/emailReport";
import CommerceTab from "screens/client/commerce/CommerceTab";
import CommerceMenudeoScreen from "screens/client/commerce/CommerceMenudeoScreen";
import ImportSalePointScreen from "screens/admin/import/ImportSalePointScreen";
import ImportCommerceScreen from "screens/admin/import/ImportCommerceScreen";
import ImportTabScreen from "screens/admin/import/ImportTabScreen";
import HomologacionTabScreen from "screens/admin/provider/errorcodes/HomologacionTabScreen";
import HomologacionPendientesScreen from "screens/admin/provider/errorcodes/HomologacionPendientesScreen";
import { PanelServerStatsScreen, ServerTabScreen } from "screens/admin/server";
import { AclaracionesScreen, TaskScreen, TaskTabScreen } from "screens/admin/taks";
import EditTaskScreen from "screens/admin/taks/EditTaskScreen";
import BackupScreen from "screens/report/BackupScreen";
import { AbonosScreen, AbonosTabScreen, CuentasScreen, CreateAbonoScreen, CreateCuentaScreen, EditCuentaScreen, AbonosAdminTabScreen, NotificacionesHistorialAbonosScreen } from "screens/abonos";
import NotificacionAbonosScreen from "screens/abonos/NotificacionAbonosScreen";
import AbonosHistorialScreen from "screens/abonos/AbonosHistorialScreen";
import HelpManualScreen from "screens/help/HelpManualScreen";
import { ProductAssignmentTabScreen, ProductAssignmentTableScreen, ProductAssignmentTypeTabScreen } from "screens/admin/productAssignment";
import BehaviorReportScreen from "screens/report/BehaviorReportScreen";
import { saveRedirectAfterLogin } from "helpers/authentication";

const RootRoutes = () => {
  const { token } = useSelector(store => store.session)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.search === "?session_expired") {
      dispatch(cleanSession())
      navigate("/")
    } else if (!token && !location.pathname.includes('/newpass') && !location.pathname.includes('/aviso') && !location.pathname.includes('/alerta/')) {
      saveRedirectAfterLogin(location.pathname + location.search)
      navigate("/")
    }
    // eslint-disable-next-line
  }, [token])

  return (
    <Routes>
      <Route path='/newpass' element={<LoginScreen />} />
      <Route path='/aviso' element={<LoginScreen />} />
      <Route path='/alerta/:id' element={<PublicAlertTxnsMonitorScreen />} />
      <Route path='/' element={token ? <MainScreen /> : <LoginScreen />}>
        <Route path='*' element={<Redirect path='/' />} />
        <Route path='' element={<Redirect path='/' />} />
        <Route path='panel' element={<PanelScreen />}>
          <Route path="transacciones" element={<PanelTransactionsScreen />} />
          <Route path="abonos" element={<PanelPaymentsScreen />} />
          <Route path="bitacora" element={<PanelBinnacleScreen />} />
        </Route>
        <Route path="transacciones" element={<PanelTransactionsScreen />} />
        <Route path="abonos" element={<PanelPaymentsScreen />} />
        <Route path="bitacora" element={<PanelBinnacleScreen />} />
        <Route path="graficas" element={<Graficas />} />
        <Route path='admin'>
          <Route path="ajustes" element={<SettingsScreen />} />
          <Route path='productos' element={<ProductTabScreen />}>
            <Route path="tae" element={<ProductScreen />} />
            <Route path="pds" element={<ProductsPaymentServiceScreen />} />
            <Route path="pin" element={<ProductsPINScreen />} />
          </Route>
          <Route path='productos'>
            <Route path="tae">
              <Route path='operadoras' >
                <Route index element={<OperatorScreen />} />
                <Route path='crear' element={<ProductCreateOperatorScreen />} />
                <Route path='editar' element={<ProductEditOperatorScreen />} />
                <Route path='legales'>
                  <Route index element={<ProductLawfulOperatorScreen />} />
                  <Route path='crear' element={<CreateLawfulOperatorScreen />} />
                  <Route path='editar' element={<EditLawfulOperatorScreen />} />
                </Route>
              </Route>
              <Route path='segmentos' >
                <Route index element={<SegmentScreen />} />
                <Route path='crear' element={<ProductCreateSegmentScreen />} />
                <Route path='editar' element={<ProductEditSegmentScreen />} />
              </Route>
              <Route path='denominaciones' >
                <Route index element={<DenominationScreen />} />
                <Route path='crear' element={<ProductCreateDenominationScreen />} />
                <Route path='editar' element={<ProductEditDenominationScreen />} />
                <Route path='extradenominaciones' >
                  <Route index element={<ExtraDenominationScreen />} />
                  <Route path='crear' element={<CreateExtraDenominationScreen />} />
                  <Route path='editar' element={<EditExtraDenominationScreen />} />
                </Route>
              </Route>
            </Route>
            <Route path="pds">
              <Route path='segmentos' >
                <Route index element={<SegmentsPaymentServiceScreen />} />
                <Route path='crear' element={<CreateSegmentPaymentServiceScreen />} />
                <Route path='editar' element={<EditSegmentPaymentServiceScreen />} />
              </Route>
              <Route path='productos' >
                <Route index element={<ProductsPaymentServiceScreen />} />
                <Route path='crear' element={<CreatePaymentServiceScreen />} />
                <Route path='editar' element={<EditPaymentServiceScreen />} />
              </Route>
            </Route>
            <Route path="pin">
              <Route path='segmentos' >
                <Route index element={<SegmentsPINScreen />} />
                <Route path='crear' element={<CreateSegmentPINScreen />} />
                <Route path='editar' element={<EditSegmentPINScreen />} />
              </Route>
              <Route path='productos' >
                <Route index element={<ProductsPINScreen />} />
                <Route path='crear' element={<CreatePINScreen />} />
                <Route path='editar' element={<EditPINScreen />} />
              </Route>
            </Route>
          </Route>
          <Route path='proveedores' >
            <Route index element={<ProviderScreen />} />
            <Route path='crear' element={<CreateProviderScreen />} />
            <Route path='editar' element={<EditProviderScreen />} />
            <Route path='consultas-estado' element={<ProviderStatusQueriesScreen />} />
            <Route path='monitor' element={<MonitorProviderTransactionsScreen />} />
            <Route path='saldo' element={<ProviderBalanceScreen />} />
            <Route path='carriers'>
              <Route index element={<CarriersScreen />} />
              <Route path='create' element={<CreateCarrierScreen />} />
              <Route path='edit' element={<EditCarrierScreen />} />
            </Route>
            <Route path='creds'>
              <Route index element={<CredsScreen />} />
              <Route path='create' element={<CredsAddScreen />} />
              <Route path='edit' element={<CredsEditService />} />
              <Route path='productos' element={<CredsProductTabScreen />}>
                <Route path="tae" element={<CredTAEScreen />} />
                <Route path="pds" element={<CredPDSScreen />} />
                <Route path="pin" element={<CredPINScreen />} />
              </Route>
              <Route path='productos' >
                <Route path="tae">
                  <Route path='operadoras' element={<CredTAEOperatorsScreen />} />
                  <Route path='segmentos' element={<CredTAESegmentsScreen />} />
                  <Route path="productos" >
                    <Route index element={<CredTAEProductsScreen />} />
                    <Route path="editar" element={<EditCredTAEProductScreen />} />
                  </Route>
                </Route>
                <Route path="pds">
                  <Route path="segmentos" element={<CredPDSSegmentScreen />} />
                  <Route path="productos" >
                    <Route index element={<CredPDSProductScreen />} />
                    <Route path="editar" element={<EditCredPDSProductScreen />} />
                  </Route>
                </Route>
                <Route path="pin">
                  <Route path="segmentos" element={<CredPINSegmentScreen />} />
                  <Route path="productos" >
                    <Route index element={<CredPINProductScreen />} />
                    <Route path="editar" element={<EditCredPINProductScreen />} />
                  </Route>
                </Route>
              </Route>
              <Route path='amounts'>
                <Route index element={<AmountsScreen />} />
                <Route path='create' element={<CreateAmountScreen />} />
                <Route path='edit' element={<EditAmountScreen />} />
              </Route>
            </Route>
            <Route path='errorcodes' element={<ErrorCodesTabScreen />}>
              <Route path='homologados'>
                <Route index element={<ErrorCodesHomologadosScreen />} />
                <Route path='create' element={<CreateErrorCodesScreen />} />
                <Route path='edit' element={<EditErrorCodesScreen />} />
              </Route>
              <Route path='recibidos' element={<ErrorCodesRecibidosScreen />} />
            </Route>
            <Route path="conciliaciones" >
              <Route index element={<ConciliacionScreen />} />
              <Route path='detail' element={<ConciliacionDetailScreen />} />
              <Route path='history' element={<ConciliacionHistoryScreen />} />
            </Route>
            <Route path='hebecodes'>
              <Route index element={<HebeCodesScreen />} />
              <Route path='create' element={<HebeCodesCreateScreen />} />
              <Route path='edit' element={<HebeCodesEditScreen />} />
            </Route>
          </Route>
          <Route path='conectores' >
            <Route index element={<ConnectorScreen />} />
            <Route path='crear' element={<CreateConnectorScreen />} />
            <Route path='editar' element={<EditConnectorScreen />} />
          </Route>
          <Route path='alertas' element={<AlertTab />} >
            <Route path='eventos' element={<AlertMonitorScreen />} />
            <Route path='configuracion' element={<AlertsScreen />}>
              <Route path='transaccionales' element={<TransactionsAlertsScreen />} />
              <Route path='sistema' element={<SystemAlertsScreen />} />
            </Route>
            <Route path='intermitencias' element={<IntermittenceScreen />} />
          </Route>
          <Route path='alertas' >
            <Route path='eventos'>
              <Route path='transacciones' element={<AlertTxnsMonitorScreen />} />
            </Route>
            <Route path='configuracion'>
              <Route path='transaccionales'>
                <Route path='crear' element={<CreateAlertScreen />} />
                <Route path='editar' element={<EditAlertScreen />} />
              </Route>
              <Route path='sistema'>
                <Route path='crear' element={<CreateAlertScreen system={true} />} />
                <Route path='editar' element={<EditAlertScreen />} />
              </Route>
            </Route>
            <Route path='intermitencias' >
              <Route path='transacciones' element={<IntermittenceTxnsScreen />} />
            </Route>
          </Route>
          <Route path='servicios' >
           
            <Route path='historial' element={<ServiceMonitorHistorialScreen />} />
            <Route path='consumos' element={<ProviderBalanceHistoryScreen />} />
          </Route>
          <Route path='servidor' element={<ServerTabScreen />}>
            <Route path='estado' element={<PanelServerStatsScreen />} />
            <Route path='configuracion' element={<SettingsScreen />} />
             <Route path='monitor' element={<ServiceMonitorScreen />} />
          </Route>
          <Route path='tareas' element={<TaskTabScreen />}>
            <Route path='listado' element={<TaskScreen />} />
            <Route path='aclaraciones' element={<AclaracionesScreen />} />
          </Route>
          <Route path='tareas'>
            <Route path='editar' element={<EditTaskScreen />} />
          </Route>
          <Route path='asignacion-productos' element={<ProductAssignmentTabScreen />}>
            <Route path='proveedores' element={<ProductAssignmentTypeTabScreen scope={'proveedores'} />}>
              <Route path='tae' element={<ProductAssignmentTableScreen scope={'proveedores'} type={'tae'} />} />
              <Route path='pds' element={<ProductAssignmentTableScreen scope={'proveedores'} type={'pds'} />} />
              <Route path='pin' element={<ProductAssignmentTableScreen scope={'proveedores'} type={'pin'} />} />
            </Route>
            <Route path='comercios' element={<ProductAssignmentTypeTabScreen scope={'comercios'} />}>
              <Route path='tae' element={<ProductAssignmentTableScreen scope={'comercios'} type={'tae'} />} />
              <Route path='pds' element={<ProductAssignmentTableScreen scope={'comercios'} type={'pds'} />} />
              <Route path='pin' element={<ProductAssignmentTableScreen scope={'comercios'} type={'pin'} />} />
            </Route>
          </Route>
          <Route path='homologacion' >
            <Route path='' element={<HomologacionTabScreen />}>
              <Route index element={<HomologationScreen />} />
              <Route path='pendientes' element={<HomologacionPendientesScreen />} />
            </Route>
            <Route path='errorcodes' element={<ErrorCodesTabScreen />}>
              <Route path='homologados' element={<ErrorCodesHomologadosScreen />} />
              <Route path='recibidos' element={<ErrorCodesRecibidosScreen />} />
              <Route path='respaldo' element={<ErrorCodesRespaldoScreen />} />
            </Route>
            <Route path='errorcodes' >
              <Route path='homologados'>
                <Route path='create' element={<CreateErrorCodesScreen />} />
                <Route path='edit' element={<EditErrorCodesScreen />} />
              </Route>
              <Route path='respaldo'>
                <Route path='create' element={<CreateErrorCodesRespaldoScreen />} />
                <Route path='edit' element={<EditErrorCodesRespaldoScreen />} />
              </Route>
            </Route>
          </Route>
          <Route path='importar' element={<ImportTabScreen />}>
            <Route path='comercios' element={<ImportCommerceScreen />} />
            <Route path='puntos_de_venta' element={<ImportSalePointScreen />} />
          </Route>
        </Route>
        <Route path='ruteo'>
          <Route path='simulador' element={<SimulatorScreen />} />
          <Route path="ladas">
            <Route index element={<LadasScreen />} />
            <Route path='crear' element={<CreateLadaScreen />} />
            <Route path='editar' element={<EditLadaScreen />} />
          </Route>
          <Route path="panel" element={<RouteTabScreen />}>
            <Route path="tae" element={<TAETabScreen />} >
              <Route index element={<TAERouteScreen />} />
              <Route path='excepciones' element={<ExceptionScreen />} />
            </Route>
            <Route path="pds" element={<PDSRouteScreen />} />
            <Route path="pin" element={<PINRouteScreen />} />
          </Route>
          <Route path="panel" >
            <Route path="tae" >
              <Route path='excepciones'>
                <Route path='crear' element={<CreateExceptionScreen />} />
                <Route path='editar' element={<EditExceptionScreen />} />
                <Route path='historial' element={<ExceptionHistoryScreen />} />
                <Route path='historial/transacciones' element={<ExceptionHistoryTxnsScreen />} />
              </Route>
            </Route>
          </Route>
        </Route>
        <Route path='seguridad'>
          <Route path="usuarios" >
            <Route index element={<UserScreen />} />
            <Route path='crear' element={<CreateUserScreen />} />
            <Route path='editar' element={<EditUserScreen />} />
          </Route>
          <Route path="administradores" >
            <Route index element={<AdminScreen />} />
            <Route path='crear' element={<CreateUserScreen type="admin" />} />
            <Route path='editar' element={<EditUserScreen type="admin" />} />
          </Route>
          <Route path="roles" >
            <Route index element={<RoleScreen />} />
            <Route path='crear' element={<CreateRoleScreen />} />
            <Route path='editar' element={<EditRoleScreen />} />
          </Route>
          <Route path="permisos" >
            <Route index element={<PermissionScreen />} />
            <Route path='crear' element={<CreatePermissionScreen />} />
            <Route path='editar' element={<EditPermissionScreen />} />
          </Route>
        </Route>
        <Route path="cliente">
          <Route path="comercios" element={<CommerceTab />} >
            <Route path="distribuidores" element={<CommerceScreen />} />
            <Route path="menudeo" element={<CommerceMenudeoScreen />} />
          </Route>
          <Route path="arbol_comercios" element={<CommerceTreeScreen />} />
          <Route path="comercios" >
            <Route path='crear' element={<CreateCommerceScreen />} />
            <Route path='editar' element={<EditCommerceScreen />} />
          </Route>
          <Route path="bolsas" >
            <Route index element={<BagScreen />} />
            <Route path='crear' element={<CreateBagScreen />} />
            <Route path='editar' element={<EditBagScreen />} />
            <Route path='operaciones' element={<BagOperationsScreen />} />
            <Route path='productos' element={<BagProductTabScreen />}>
              <Route path="tae">
                <Route index element={<BagTAEScreen />} />
                <Route path='operadoras' element={<BagTAEOperatorScreen />} />
                <Route path='regiones' element={<BagTAERegionScreen />} />
                <Route path='segmentos' element={<BagTAESegmentScreen />} />
                <Route path='denominaciones' element={<BagTAEDenominationScreen />} />
              </Route>
              <Route path="pds">
                <Route index element={<BagPDSScreen />} />
                <Route path="segmentos" element={<BagPDSSegmentScreen />} />
                <Route path="productos" element={<BagPDSProductScreen />} />
              </Route>
              <Route path="pin">
                <Route index element={<BagPINScreen />} />
                <Route path="segmentos" element={<BagPINSegmentScreen />} />
                <Route path="productos" element={<BagPINProductScreen />} />
              </Route>
            </Route>
          </Route>
          <Route path="puntos_de_venta" >
            <Route index element={<SalePointScreen />} />
            <Route path='crear' element={<CreateSalePointScreen />} />
            <Route path='editar' element={<EditSalePointScreen />} />
          </Route>
          <Route path="grupos" >
            <Route index element={<GroupScreen />} />
            <Route path='crear' element={<CreateGroupScreen />} />
            <Route path='editar' element={<EditGroupScreen />} />
          </Route>
        </Route>
        <Route path='abonos' >
          <Route path='comercio' element={<AbonosTabScreen />}>
            <Route path='notificaciones' element={<AbonosScreen />} />
            <Route path='historial' element={<AbonosHistorialScreen />} />
          </Route>
          <Route path='admin' element={<AbonosAdminTabScreen />}>
            <Route path='notificaciones' element={<NotificacionAbonosScreen />} />
            <Route path='historial' element={<NotificacionesHistorialAbonosScreen />} />
            <Route path='cuentas' element={<CuentasScreen />} />
          </Route>
          <Route path='comercio/nuevo' element={<CreateAbonoScreen />} />
          <Route path='admin/cuentas'>
            <Route path='crear' element={<CreateCuentaScreen />} />
            <Route path='editar' element={<EditCuentaScreen />} />
          </Route>
        </Route>
        <Route path='venta' element={<SaleTabScreen />}>
          <Route path="tiempo-aire" element={<AirTimeSaleScreen />} />
          <Route path="servicios" element={<ServicePaymentSaleScreen />} />
          <Route path="tarjetas-regalo" element={<ElectronicPinSaleScreen />} />
        </Route>
        <Route path='ayuda'>
          <Route path='manual-administrador' element={<HelpManualScreen />} />
        </Route>
        <Route path="reportes">
          <Route path="detallado" element={<DetailedScreen />} />
          <Route path="red" element={<DetailedScreen network={true} />} />
          <Route path="backup" element={<BackupScreen />} />
          <Route path="saldos" element={<BalancesScreen />} />
          <Route path="bitacora" element={<BinnacleScreen />} />
          <Route path="totales" element={<TotalReportScreen />} />
          <Route path="saldo_diario" element={<DailyTotalReportScreen />} />
          <Route path="comercio" element={<CommerceReportScreen />} />
          <Route path="abonos" element={<AbonosReportScreen />} />
          <Route path="conciliacion_diaria" element={<ConciliacionDiariaScreen />} />
          <Route path="liberaciones" element={<LiberacionesReportScreen />} />
          <Route path="buscar_txn" element={<SearchTxnReportScreen />} />
          <Route path="comportamiento" element={<BehaviorReportScreen />} />
          <Route path="correos" element={<EmailReportTab />} >
            <Route index element={<EmailReportScreen />} />
            <Route path='historial_global' element={<EmailReportGlobalHistoryScreen />} />
          </Route>
          <Route path="correos" >
            <Route path='crear' element={<CreateEmailReportScreen />} />
            <Route path='editar' element={<EditEmailReportScreen />} />
            <Route path='historial' element={<EmailReportHistoryScreen />} />
          </Route>
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes >
  )
}

const Redirect = ({ path }) => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(path)
    // eslint-disable-next-line
  }, [path])
}

export default RootRoutes;